export default "__VITE_ASSET__Qq_fUq4N__"